export const orderStatus = [
  {
    id: 1,
    value: "Pending",
    color: "default",
  },
  {
    id: 2,
    value: "Accepted",
    color: "blue",
  },
  {
    id: 3,
    value: "In Process",
    color: "gold",
  },
  {
    id: 4,
    value: "Ready For Dispatch",
    color: "volcano",
  },
  {
    id: 5,
    value: "Arrived",
    color: "orange",
  },
  {
    id: 6,
    value: "Delivered",
    color: "blue",
  },
  {
    id: 7,
    value: "Completed",
    color: "green",
  },
];

export const paymentMethod = [
  {
    id: 1,
    value: "Cash on Delivery",
  },
  {
    id: 2,
    value: "Online",
  },
];

export function formatDate(string) {
  var options = { year: "numeric", month: "long", day: "numeric" };
  return new Date(string).toLocaleDateString([], options);
}
